import { Component, OnInit } from '@angular/core';
import { ClientService } from '../../../services/client.service';

@Component({
  selector: 'app-deposit-dashboard-card',
  templateUrl: './deposit-dashboard-card.component.html',
  styleUrls: ['./deposit-dashboard-card.component.scss']
})
export class DepositDashboardCardComponent implements OnInit {

  count: number = 0;

  constructor(
    private clientService: ClientService
  ) { }

  ngOnInit(): void {
    this.clientService.countAll().subscribe(
      success => this.count = typeof success==='number'? success:0,
      error => console.error(error)
    )
  }

}
